import isNil from 'lodash/isNil'
import { Language } from '../languages/types'
import { ContentType } from './content-type/types'

const BASE_URL = 'https://yogainternational.com'
const PREVIEW_PATHNAME = '/preview'

const ES_PATHNAME = '/es'

export const CONTENT_HAS_NOT_PREVIEW_MARK = ''

function convertContentTypeToParam (contentType: ContentType) {
  switch (contentType) {
    case ContentType.YI_CLASS: {
      return 'class'
    }

    case ContentType.YI_MEDITATION: {
      return 'meditation'
    }

    case ContentType.YI_ARTICLE: {
      return 'article'
    }

    case ContentType.YI_COURSE: {
      return 'coursePlayer'
    }

    case ContentType.YI_COURSE_SALES: {
      return 'course'
    }

    case ContentType.YI_TEACHER: {
      return 'profile'
    }

    case ContentType.YI_POSE: {
      return 'pose'
    }

    default:
      return CONTENT_HAS_NOT_PREVIEW_MARK
  }
}

export function getYIContentPreviewUrl ({
  contentType,
  language,
  yiContentId,
}: {
  yiContentId: string
  language: Language
  contentType: ContentType
}): string {
  const type = convertContentTypeToParam(contentType)
  if (type === CONTENT_HAS_NOT_PREVIEW_MARK || isNil(yiContentId)) {
    return CONTENT_HAS_NOT_PREVIEW_MARK
  }

  return `${BASE_URL}${language === 'es' ? ES_PATHNAME : ''}${PREVIEW_PATHNAME}/?type=${convertContentTypeToParam(contentType)}&id=${yiContentId}`
}
